import React from "react";
import { BasicChequeredBoard, BasicChequeredBoardProps } from "../../components/BasicChequeredBoard/BasicChequeredBoard";
import { FaqAccordionGroupProps } from "../../components/FaqAccordionGroup/FaqAccordionGroup";
import { GreyCard, GreyCardProps } from "../../components/GreyCard";
import { GroupedComponents } from "../../components/GroupedComponents";
import { Links, LinksProps } from "../../components/Links";
import { List } from "../../components/List";
import { Paragraph, ParagraphProps } from "../../components/Paragraph";
import { ProcessSteps, ProcessStepsProps } from "../../components/ProcessSteps";
import { Responsibilities, ResponsibilitiesProps } from "../../components/Responsibilities";
import { SeoHeaderProps } from "../../components/SeoHeader";
import { ServiceCataloguePageWrapper } from "../../components/ServiceCataloguePageWrapper";
import { GenericListProps } from "../../types/GenericListType";

export interface VectorEquipmentFaultsPageProps {
  seo?: SeoHeaderProps;
  pageTitle: string;
  paragraphs?: ParagraphProps[];
  chequeredBoard?: BasicChequeredBoardProps;
  responsibilities?: ResponsibilitiesProps[];
  processes?: ProcessStepsProps[];
  wantToReport?: GreyCardProps;
  lists?: GenericListProps[];
  linksList?: LinksProps[];
  faqs?: FaqAccordionGroupProps;
}

export const VectorEquipmentFaultsPage: React.FC<VectorEquipmentFaultsPageProps> = ({
  seo,
  pageTitle,
  paragraphs,
  chequeredBoard,
  responsibilities,
  processes,
  wantToReport,
  lists,
  linksList,
  faqs,
}) => {
  return (
    <ServiceCataloguePageWrapper seo={seo} title={pageTitle} faqs={faqs}>
      {paragraphs && paragraphs[0] && <Paragraph {...paragraphs[0]} />}
      {chequeredBoard && <BasicChequeredBoard {...chequeredBoard} />}
      {paragraphs && paragraphs[1] && <Paragraph {...paragraphs[1]} />}
      {responsibilities && responsibilities[0] && <Responsibilities {...responsibilities[0]} />}
      {processes && processes[0] && <ProcessSteps {...processes[0]} />}
      {wantToReport && <GreyCard {...wantToReport} />}
      <GroupedComponents>
        {paragraphs && paragraphs[2] && <Paragraph {...paragraphs[2]} />}
        {lists && lists[0] && <List {...lists[0]} />}
      </GroupedComponents>
      {linksList && linksList[0] && <Links {...linksList[0]} />}
    </ServiceCataloguePageWrapper>
  );
};
